import { render, staticRenderFns } from "./OurIslandsSection.vue?vue&type=template&id=151411da&scoped=true&"
import script from "./OurIslandsSection.vue?vue&type=script&lang=js&"
export * from "./OurIslandsSection.vue?vue&type=script&lang=js&"
import style0 from "./OurIslandsSection.vue?vue&type=style&index=0&id=151411da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151411da",
  null
  
)

export default component.exports